export default __webpack_public_path__ + "static/media/whistle.01f3e888.svg";